var map = {
	"./Mr Johnson.jpg": 2056,
	"./abdullahi.jpg": 4701,
	"./ayomide.jpg": 9730,
	"./ayoola.jpg": 3795,
	"./elishaa.jpg": 26,
	"./emurotu.jpg": 7898,
	"./esther.jpg": 2645,
	"./estherokunola.jpg": 8295,
	"./favour.jpg": 7393,
	"./felix.jpg": 7353,
	"./feranmi.jpg": 8541,
	"./ifeoluwa.jpg": 6091,
	"./joshua.jpg": 6059,
	"./kolapo.jpg": 7276,
	"./mary.jpg": 4377,
	"./mercy.jpg": 831,
	"./micheal.jpg": 546,
	"./moses.jpg": 9245,
	"./odunayo.jpg": 7583,
	"./paul.jpg": 1479,
	"./segun.jpg": 411,
	"./temitope.jpg": 5275,
	"./timileyin.jpg": 937,
	"./titilayo.jpg": 3890
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3665;